import queryString from 'query-string'
import { ImageAPI } from './types'

export const imageApi: ImageAPI = ky => {
  return {
    async fetch({ patientId, isImportant, cursor }) {
      return ky(`patient/${patientId}/image/`, {
        method: 'get',
        searchParams: queryString.stringify({
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_important: isImportant,
          cursor
        })
      }).json()
    },

    async fetchThumbnail({ patientId, imageId }) {
      return ky(`patient/${patientId}/image/${imageId}/thumbnail/`, {
        method: 'get'
      }).blob()
    },

    async fetchImage({ patientId, imageId }) {
      return ky(`patient/${patientId}/image/${imageId}/download/`, {
        method: 'get'
      }).blob()
    },

    async fetchOne({ patientId, imageId }) {
      return ky(`patient/${patientId}/image/${imageId}/`, {
        method: 'get'
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/image/`, {
        method: 'post',
        body: JSON.stringify({
          title: payload.title,
          description: payload.description,
          isImportant: payload.isImportant || false,
          // eslint-disable-next-line @typescript-eslint/camelcase
          file_name: payload.fileName,
          // eslint-disable-next-line @typescript-eslint/camelcase
          file_content: payload.fileContent
        })
      }).json()
    },

    async update({ patientId, imageId, payload }) {
      return await ky(`patient/${patientId}/image/${imageId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async updateImportant({ patientId, imageId, isImportant }) {
      return await ky(`patient/${patientId}/image/${imageId}/`, {
        method: 'patch',
        body: JSON.stringify({ isImportant })
      }).json()
    },

    async patch({ patientId, imageId, payload }) {
      return await ky(`patient/${patientId}/image/${imageId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async delete({ patientId, imageId }) {
      await ky(`patient/${patientId}/image/${imageId}/`, {
        method: 'delete'
      })
    }
  }
}
